import "./title.style.scss";
const Title = ({ title }) => {
  return <p className="title text-secondary font-bold text-lg">{title}</p>;
};

export default Title;
